import * as React from 'react';
import { SVGProps } from 'react';

const IconKernFilledSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M12 10c2.314 0 4.456-.408 6.058-1.109.754-.33 1.428-.742 1.942-1.243V19.5c0 1.933-3.582 3.5-8 3.5s-8-1.567-8-3.5V7.648c.514.5 1.188.913 1.942 1.243C7.544 9.591 9.686 10 12 10Z" />
    <path d="M4 4.5C4 2.567 7.582 1 12 1s8 1.567 8 3.5S16.418 8 12 8 4 6.433 4 4.5Z" />
  </svg>
);
export default IconKernFilledSizeM;
